import React from 'react';
import styled from 'styled-components';
import logo from'../assets/NEC_logo-icon.png';

function Navbar(props) {
    return (
        <NavbarContainer>
            <Text style={{color:'white'}}>
                باشگاه مشتریان&nbsp;
                <span> NEC </span>
            </Text>
            <InputContainer>
                <img src={logo} alt="NEC"/>
            </InputContainer>
        </NavbarContainer>
    );
}

const NavbarContainer=styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 10%;
    @media screen and (min-width: 320px) and (max-width: 1080px){
        height: max-content;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
    }
`;

const Text=styled.h2`
    span{
        font-weight: bold;
        font-size: 1.8rem;
        color: #2e3192;
        text-shadow:0px 0px 8px white;
    }    
    @media screen and (min-width: 320px) and (max-width: 1080px){
        font-size: 0.8rem;
        span{
            font-size: 0.9rem;
        }
    }
`;

const InputContainer=styled.div`
    margin:0 1.2rem;
    display: flex;
    img{
        width:3.5rem;
        height:3.5rem;
    }
`;

export default Navbar;